import { z } from 'zod';
import { skeletonBlockPropsSchema } from '../SkeletonBlock/SkeletonBlock';
import { TextVariant } from '../Text/Text';

/** Known copy reserves its natural Text geometry; lines estimate unknown copy. */
export const skeletonTextPropsSchema = skeletonBlockPropsSchema
  .pick({
    width: true,
    active: true,
    testID: true,
  })
  .extend({
    variant: TextVariant.default('b1Regular'),
    shape: z.enum(['lines', 'block']).default('lines'),
    text: z.string().optional(),
    lines: z.number().int().min(1).max(6).default(1),
  })
  .strict();

export type SkeletonTextProps = z.infer<typeof skeletonTextPropsSchema>;
